import React, { useEffect, useState } from 'react';
import './TrustBanner.css';

/**
 * Above-the-fold trust signals (Deck Out / Hobbiesville pattern).
 * Pulls real numbers from /api/reviews/stats and /api/seo/stats so the
 * banner is honest, not fabricated.
 */
export default function TrustBanner() {
  const [stats, setStats] = useState({
    review_avg: null,
    review_count: null,
    happy_customers: null,
    free_ship_threshold: 100,
  });

  useEffect(() => {
    fetch('/api/reviews/aggregate')
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d) setStats(s => ({ ...s, review_avg: d.average_rating, review_count: d.total_reviews })); })
      .catch(() => {});
    fetch('/api/seo/stats/customers')
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.count) setStats(s => ({ ...s, happy_customers: d.count })); })
      .catch(() => {});
  }, []);

  const items = [
    {
      label: stats.review_avg
        ? `${Number(stats.review_avg).toFixed(1)}/5 stars`
        : 'Trusted by collectors',
      sub: stats.review_count
        ? `${stats.review_count}+ verified reviews`
        : 'Reviewed on every order',
    },
    {
      label: `Free shipping over $${stats.free_ship_threshold}`,
      sub: 'Tracked across Canada',
    },
    {
      label: 'Buylist — same-day quotes',
      sub: '+20% bonus in store credit',
    },
    {
      label: 'Secure checkout',
      sub: 'Stripe · Apple Pay · Google Pay',
    },
  ];

  return (
    <section className="trust-banner" aria-label="Why shop with us">
      {items.map((it, i) => (
        <div key={i} className="trust-banner__item">
          <div>
            <div className="trust-banner__label">{it.label}</div>
            <div className="trust-banner__sub">{it.sub}</div>
          </div>
        </div>
      ))}
    </section>
  );
}
